import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { AutofocusDirective } from '@shared/directives/autofocus.directive';
import { TrimValueAccessor } from '@shared/directives/trimValueAccessor.directive';
import { invalidDateRangeValidator, onlyWhitespaceValidator } from '@shared/forms/forms.validators';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-period-dialog',
  templateUrl: './add-period-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatDialogTitle,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    MatDialogContent,
    AutofocusDirective,
    MatDialogActions,
    MatButton,
    MatSuffix,
    TrimValueAccessor,
  ],
})
export class AddPeriodDialogComponent {
  private readonly _dialogRef = inject(MatDialogRef<AddPeriodDialogComponent>);
  private readonly _fb = inject(NonNullableFormBuilder);

  public readonly form = this._fb.group(
    {
      fromTime: ['', Validators.required],
      toTime: ['', Validators.required],
      name: ['', [Validators.required, onlyWhitespaceValidator()]],
    },
    { validators: [invalidDateRangeValidator()] },
  );

  public close() {
    const { fromTime, toTime, name } = this.form.value;

    if (fromTime && toTime && name) {
      this._dialogRef.close({ fromTime, toTime, name });
    }
  }
}
